import { Component, Injector, Optional, Input } from '@angular/core';

import { AdresService } from 'src/app/core/service/adres.service';
import { Adres } from 'src/app/core/dto/adres';
import { Filter, FilterBuilder, PagedCollectionComponent, ColumnDefinition, createColumnDefinitions, SearchableType } from '@mango/core';
import { Relatie } from 'src/app/core/dto/relatie';
import { TypeAdres } from 'src/app/core/enums/type-adres';
import { MatSortable } from '@angular/material/sort';

@Component({
    selector: 'c-i-j-borculo-adres-collection',
    templateUrl: './adres-collection.component.html'/*,
    styleUrls: ['./adres-collection.component.css'] */
})
export class AdresCollectionComponent extends PagedCollectionComponent<Adres> {
    columnDefinitions: ColumnDefinition[] = createColumnDefinitions<Adres>([
		{ colDef: 'typeAdres', prop: x => x.typeAdres, searchable: { type: SearchableType.Enum, enum: TypeAdres } },
		{ colDef: 'naam', prop: x => x.naam, searchable: SearchableType.String },
		{ colDef: 'adres1', prop: x => x.adres1, searchable: SearchableType.String },
		{ colDef: 'postcode', prop: x => x.postcode, searchable: SearchableType.String },
		{ colDef: 'plaats', prop: x => x.plaats, searchable: SearchableType.String },
		{ colDef: 'land', prop: x => x.landID.omschrijving, searchable: SearchableType.String },		
    ]);
    displayedColumns = this.columnDefinitions.map(x => x.colDef);

	typeAdres = TypeAdres;

    constructor(public service: AdresService, @Optional() protected filter: Filter<Adres>, injector: Injector) {
        super('/adres/adres', injector, Adres);

		this.initInput('relatieID', this.filterBuilder.equal(x => x.relatieID.id));

		this.filter.onGetChipLabel(x => x.typeAdres, () => 'Type adres');
        this.filter.onGetChipLabel(x => x.naam, () => 'Naam');
		this.filter.onGetChipLabel(x => x.adres1, () => 'Adres1');
		this.filter.onGetChipLabel(x => x.postcode, () => 'Postcode');
		this.filter.onGetChipLabel(x => x.plaats, () => 'Plaats');
		this.filter.onGetChipLabel(x => x.landID.omschrijving, () => 'Land');

    }

	
    ngOnInit() {
        super.ngOnInit();
        this.sort.sort(<MatSortable>{id: 'relatieID', start: 'asc'});
        this.sort.sort(<MatSortable>{id: 'adres1', start: 'asc'});
	}


	displayColumn(colDef: ColumnDefinition, ix: number) {
		// Hide columns that are already filtered on
		if(colDef.colDef == 'relatieID' && this.relatieID != null) { return false; }

		return super.displayColumn(colDef, ix);
	}

	@Input() set relatieID(val: Relatie) { this.handleInput('relatieID', val.id); }

	getAdresType(value) {

		switch (Number(value)) {
			case TypeAdres.Bezoek:
				return "Bezoek";
			case TypeAdres.Post:
				return "Post";
			case TypeAdres.Certificaat:
				return "Certificaat";
			case TypeAdres.Verzenden:
				return "Verzenden";
			case TypeAdres.Overig:
				return "Overig";
			default:
				return value;
		}
	}

}